import { render, staticRenderFns } from "./TheDiscrepancyReport.vue?vue&type=template&id=0408795a&scoped=true&"
import script from "./TheDiscrepancyReport.vue?vue&type=script&lang=js&"
export * from "./TheDiscrepancyReport.vue?vue&type=script&lang=js&"
import style0 from "./TheDiscrepancyReport.vue?vue&type=style&index=0&id=0408795a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408795a",
  null
  
)

export default component.exports